export default __webpack_public_path__ + "static/rss-b90e3fb65f5adc1e602555f68c10eeb4.svg";